<template>
  <div class="lang-selector" role="group">
    <select name="" id="" v-model="selected" @change="handleChange">
      <option
        :value="language.value"
        v-for="language in languageList"
        :key="language.id"
      >
        {{ language.name }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: "TopLanguageSelector",
  data() {
    return {
      selected: "",
      languageList: [
        { id: 1, name: "Japanese", value: "/" },
        { id: 2, name: "English", value: "/en" },
        { id: 3, name: "Chinese", value: "/cn" },
        { id: 4, name: "Portuguese", value: "/pt" },
        { id: 5, name: "Spanish", value: "/sn" },
        { id: 6, name: "Tagalog", value: "/tg" },
      ],
    };
  },
  created() {
    this.selected = this.languageList[0].value;
  },
  methods: {
    handleChange() {
      console.log(this.selected);
      this.$router.replace({ path: this.selected });
    },
  },
};
</script>

<style scoped>
.lang-selector {
  position: absolute;
  top: 4px;
  right: 4px;
}

.btn-lang-selector {
  font-size: 2rem;
  padding: 0.5rem 1.2rem;
}
select {
  background-color: rgba(224, 78, 10, 0.667);
  color: white;
  font-size: 2rem;
  padding: 0.5rem 1.2rem;
  border: 0;
  border-radius: 5%;
}
</style>